import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';

import { IpadConfigUpdateService, IpadConfigService } from '@/features/ipad-configs/services';
import {
  IIpadConfigUpdate,
  IIpadConfigsSearchingPayload,
} from '@/features/ipad-configs/interfaces';
import { QUERY_KEYS } from '@/constants';

export const useIpadConfigQuery = (serialNumber: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.ipadConfig(serialNumber),
    queryFn: async () => {
      const response = await IpadConfigService.GetIpadConfig(serialNumber);
      return response.data;
    },
    enabled: !!serialNumber,
  });
};

export const useIpadConfigMutation = (serialNumber?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (ipadConfigData: IIpadConfigUpdate) => {
      const response = await IpadConfigUpdateService.UpdateIpadConfig(ipadConfigData);
      return response.data;
    },
    onSuccess: () => {
      if (serialNumber) {
        queryClient.invalidateQueries({ queryKey: QUERY_KEYS.ipadConfig(serialNumber) });
      }
    },
  });
};

export const useDevicesSearching = (payload: IIpadConfigsSearchingPayload) => {
  return useQuery({
    queryKey: QUERY_KEYS.devicesSearching(payload),
    queryFn: () => IpadConfigService.DevicesSearching(payload),
    placeholderData: keepPreviousData,
  });
};
